import RoutesWithoutPermissions from './WithoutPermissions'
import { routes as HomeChildrenRouters } from '../pages/Home.js'

const permissionFilter = (store, routes) => {
  if(routes === undefined) {
    routes = RoutesWithoutPermissions();
    routes[routes.findIndex(x => x.name === 'Home')]['children'] = HomeChildrenRouters;
  }

  let filtered_routes = [];

  let hasPermission = (route) => {
    let {meta: {permissions = []} = {}} = route;
    return store.getters.hasGlobalPermissions({requiredPermissions: permissions});
  };

  for(let i = 0; i < routes.length; i++) {
    if (hasPermission(routes[i])) {
      filtered_routes.push(routes[i]);
    }
  }

  for (let i in filtered_routes) {
    let {children} = filtered_routes[i]

    if (children) {
      filtered_routes[i].children = permissionFilter(store, children)
    }
  }

  return filtered_routes
}

export default permissionFilter